import { DirectiveType } from '../../types';
import { AbstractMultiValueDirective } from '../abstract-multi-value-directive';
export class DefaultSource extends AbstractMultiValueDirective {
    getDirectiveName() {
        return 'default-src';
    }
    getDirectiveType() {
        return DirectiveType.Fetch;
    }
}
